import { TextField } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

export default function NewSearch({ searchValue, onChange, placeholder }) {
  return (
    <TextField
      variant="standard"
      value={searchValue}
      onChange={(e) => onChange(e)}
      placeholder={placeholder}
      fullWidth
      sx={{
        mb: "74px",
      }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        },
        htmlInput: {
          style: { textAlign: "left" },
        },
      }}
    />
  );
}
